import React, { memo } from 'react';

const BingoCell = memo(({ cell, userProgress, onClick, isHistorical }) => {
    const progress = userProgress.find((p) => p.Cell_ID === cell.id);
    const book = progress ? { Title: progress.Book_Title } : null;

    return (
        <div
            className={`bingo-cell ${progress ? "selected" : ""} ${isHistorical ? "historical" : ""}`}
            onClick={onClick}
        >
            <p>{book ? book.Title : cell.Challenge}</p>
        </div>
    );
});

BingoCell.displayName = 'BingoCell';

export default BingoCell;
